import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/roles_authorities_patch',
    name: 'POST_rolesauthority_patch',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
